import { render } from "./EditCeibaServer.vue?vue&type=template&id=71c5ea8a"
import script from "./EditCeibaServer.vue?vue&type=script&lang=js"
export * from "./EditCeibaServer.vue?vue&type=script&lang=js"
script.render = render

export default script